import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { LocalizationService } from '@abp/ng.core';

// Replaces ABP's AbpTitleStrategy so the browser tab shows the tenant name instead of the fixed
// "::AppName" (Focali). Pages that set their own title (x-pg list/details/overview) still override it.
@Injectable({ providedIn: 'root' })
export class TenantTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title, private readonly localizationService: LocalizationService) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    const appName =
      localStorage.getItem('tenant_AppName') ||
      this.localizationService.instant({ key: '::AppName', defaultValue: 'Focali' });

    const routeTitle = this.buildTitle(routerState);
    if (!routeTitle) {
      this.title.setTitle(appName);
      return;
    }

    const localizedTitle = this.localizationService.instant({ key: routeTitle, defaultValue: routeTitle });
    this.title.setTitle(`${localizedTitle} | ${appName}`);
  }
}
